import { render } from "./NotFound.vue?vue&type=template&id=dca5d5d6"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__